var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (_vm.getConfigs.side_menus &&
      _vm.getConfigs.side_menus
        .map((item) => item.menu_name)
        .includes('Bests')) ||
    _vm.getSelectedAccount.broker_name == 'RICO'
  )?_c('div',{staticClass:"flex h-full w-full flex-col gap-6 p-6"},[_vm._m(0),_c('vue-page-transition',{staticClass:"h-full z-10",attrs:{"name":"fade-in-right","id":"div-vue-page-transition"}},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 left-0 h-[360px] w-full"},[_c('span',{staticClass:"best-bg"}),_c('span',{staticClass:"gradient"})])
}]

export { render, staticRenderFns }